<div class="container" fxLayout="column" fxLayoutGap="16px" fxLayoutGap.xs="8px">
  <section class="header" fxLayout="row" fxLayoutGap="16px" fxLayoutGap.xs="8px">
    @if (acceptMember && tuitionStatus !== 1) {
      <button class="schooling" mat-raised-button color="primary" (click)="openDialog()">
        <mat-icon>add</mat-icon>
        <span>{{ 'addParticipant' | translate }}</span>
      </button>
    }

    <saf-filter-panel [placeholder]="('enterSearchTermName' | translate)" (filterChange)="applyDrawerFilters($event)"></saf-filter-panel>
  </section>
  <mat-card appearance="outlined" class="content">

    <div class="tab-table-container" [fxShow]="dataSource.data.length">
      <table mat-table [dataSource]="dataSource" id="table" class="table" matSort matSortActive="employeeLastName" matSortDirection="asc" [trackBy]="trackById">

        <ng-container matColumnDef="employeeNumber">
          <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header="employeeNumber">
            <span matTooltip="{{ 'personalNumber' | translate }}">{{ 'personalNumberShort' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let data">
            <span class="{{ checkIfStandard(data) ? (data.employee.employeeNumber ? '' : 'saf-chip') : (data.externalEmployee ? '' : 'saf-chip') }}">
              {{ checkIfStandard(data) ? (data.employee.employeeNumber ? data.employee.employeeNumber : '-') : (data.externalEmployee ? '-' : '-') }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="employeeName">
          <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header="employeeLastName">
            <span matTooltip="{{ 'employeeName' | translate }}">{{ 'employeeName' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let data">
            @if (data.employee) {
              <saf-employee-name [firstName]="data.employee.firstName" [lastName]="data.employee.name"></saf-employee-name>
            }
            @if (data.externalEmployee) {
              <span>{{ data.externalEmployee.name}}</span>
            }
            @if (!data.employee && !data.externalEmployee) {
              <span class="saf-chip">-</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ 'topicAssignmentStatus' | translate }}</th>
          <td mat-cell *matCellDef="let data">
            @switch (data.participant.status) {
              @case (0) {
                <div class="status-color grey" matTooltip="{{ 'request' | translate }}"></div>
              }
              @case (1) {
                <div class="status-color yellow" matTooltip="{{ 'assigned' | translate }}"></div>
              }
              @case (2) {
                <div class="status-color green" matTooltip="{{ 'employeeReceivedInstruction' | translate }}"></div>
              }
              @case (3) {
                <div class="status-color red" matTooltip="{{ 'failed' | translate }}"></div>
              }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef>{{ 'options' | translate }}</th>
          <td mat-cell *matCellDef="let data">
            <button mat-icon-button (click)="openDeleteDialog($event, data.participant)"
              matTooltip="{{tuitionStatus === 1 ? ('notDeletable' | translate) : ('delete' | translate)}}">
              <mat-icon class="{{tuitionStatus === 1 ? 'disabledIcon' : 'deleteIcon'}}">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr mat-row class="selectable" *matRowDef="let row; columns: tableColumns;"></tr>
      </table>
      <mat-paginator class="mat-paginator-sticky" [pageSize]="checkPageSize()" [pageSizeOptions]="pageSizeOptions"
      [length]="totalCount" [showFirstLastButtons]="true" (page)="pageChange($event)"></mat-paginator>
    </div>
    @if (!dataSource.data.length && !loading) {
      <saf-empty-message (reloadClicked)="reloadTable()"></saf-empty-message>
    }


  </mat-card>
</div>
